export default {
  titleSmartphone: {
    id: 'battery_banner_title_smartphone',
    defaultMessage:
      'Reliable battery performance to get you through an 8 hour+ series binge.',
  },
  titleMacbook: {
    id: 'battery_banner_title_macbook',
    defaultMessage:
      'Reliable battery performance to get you through a full work day.',
  },
  cta: {
    id: 'battery_banner_modal_cta',
    defaultMessage: 'See our battery standards',
  },
  imageAlt: {
    id: 'battery_banner_image_alt',
    defaultMessage: 'Refurbished device with verified battery health',
  },
} as const
